<template>
  <div id="xy_yu">
    <div class="btn_con">
      <div class="zi_b_box flex-box">
        <p
          :class="[
            'p_btn',
            { btnActive: zibtnAc == 0 },
            { mar_l: zibtnAc == 0 },
          ]"
          @click="btnClick(0)"
        >
          主播心愿
        </p>
        <p
          :class="[
            'p_btn',
            { btnActive: zibtnAc == 1 },
            { mar_r: zibtnAc == 1 },
          ]"
          @click="btnClick(1)"
        >
          用户心愿
        </p>
      </div>
    </div>

    <!-- 主播心愿 -->
    <div class="main_box" v-show="zibtnAc == 0">
      <div class="z_top_text flex-box">
        <div class="flex-box">
          <p class="p1" v-show="isAnchor > 0 && isStart != 0">
            选一个您的心愿礼物，便于和用户交换
          </p>
        </div>

        <p class="p2" v-if="isAnchor > 0" @click="myRecordFun(1)">我的记录 ></p>
      </div>
      <div class="ulBox flex-box">
        <div
          class="li_fa relativeItem"
          :style="{ width: width + 'px', height: 1.35 * width + 'px' }"
          v-for="(n, i) in anchorWishList"
          :key="i"
          @click="seleXinBox(n, i)"
        >
          <div
            class="yello_box absoluteItem centerImg"
            :style="{
              width: width + 5 + 'px',
              height: 1.35 * width + 6 + 'px',
            }"
            v-show="anchorIdx == i && showYello && isStart == 1"
          ></div>
          <div class="wai_box">
            <div class="li_con">
              <div
                class="img_b relativeItem"
                :style="{ width: width - 8 + 'px', height: width - 11 + 'px' }"
              >
                <img
                  class="imgBlock noevents-img absoluteItem centerImg"
                  :src="n.gift_image"
                />
              </div>
              <div class="g_name flex-box" :style="{ width: width - 8 + 'px' }">
                {{ n.gift_name }}
              </div>
            </div>
          </div>
          <div
            class="yi_imgtc flex-box absoluteItem centerImg"
            v-if="n.status == 1 && isStart == 1"
          >
            <img
              class="imgBlock noevents-img"
              src="../../assets/xyuan/yixuan.png"
            />
          </div>
        </div>
      </div>

      <div class="btn_sele" v-if="isStart == 0 && isAnchor > 0">
        <img class="imgBlock noevents-img" src="../../assets/xyuan/15ri.png" />
      </div>
      <div
        class="btn_sele"
        @click="seleXinFun(0)"
        v-else-if="isStart == 1 && isAnchor > 0"
      >
        <img
          class="imgBlock noevents-img"
          src="../../assets/xyuan/selexin.png"
        />
      </div>
      <div class="btn_sele" v-else-if="isStart == 2 && isAnchor > 0">
        <img class="imgBlock noevents-img" src="../../assets/xyuan/over.png" />
      </div>
    </div>

    <!-- 用户心愿 -->
    <div class="main_box" v-show="zibtnAc == 1">
      <div class="z_top_text flex-box">
        <div>
          <p class="p1" v-show="isStart > 0">选一个您要和主播交换的心愿</p>
        </div>

        <p class="p2" @click="myRecordFun(2)">我的记录 ></p>
      </div>
      <div class="ul_xin flex-box">
        <div
          class="u_li relativeItem"
          v-for="(n, i) in userWishList"
          :key="i"
          @click="seleUserFun(i)"
        >
          <img
            class="juanbg imgBlock noevents-img"
            src="../../assets/xyuan/juanbg.png"
          />
          <p class="u_xname flex-box absoluteItem">{{ n.wish_name }}</p>
          <img
            class="juan_ac imgBlock noevents-img absoluteItem"
            src="../../assets/xyuan/juanbgac.png"
            v-show="userIdx == i && isStart == 1"
          />
          <div
            class="uselet_tc absoluteItem"
            v-show="n.status == 1 && isStart == 1"
          >
            <img
              class="imgBlock noevents-img"
              src="../../assets/xyuan/uselet.png"
            />
          </div>
        </div>
      </div>
      <div class="btn_sele" @click="seleXinFun(1)" v-if="isStart == 1">
        <img
          class="imgBlock noevents-img"
          src="../../assets/xyuan/selexin.png"
        />
      </div>
      <div class="btn_sele" v-else-if="isStart == 2">
        <img class="imgBlock noevents-img" src="../../assets/xyuan/over.png" />
      </div>
      <div class="btn_sele" v-else-if="isStart == 0">
        <img class="imgBlock noevents-img" src="../../assets/xyuan/15ri.png" />
      </div>
    </div>
  </div>
</template>










<script>
export default {
  name: "xy_yu",
  props: ["isStart"],
  data() {
    return {
      zibtnAc: 0, //按钮的选中
      width: 0, // 心愿的宽度
      anchorWishList: [],
      anchorIdx: null, //选择的主播心愿下标
      userWishList: [],
      userIdx: null, //选择的用户心愿下标
      isAnchor: 0, // 0用户  大于零主播
      showYello: false,
    };
  },
  mounted() {
    this.$tool.setTitle("新语新愿");
    this.width = this.$tool.calculateWidthHeight(".ulBox", 0.2966);
    this.getWishList(); //获取心愿列表
  },

  methods: {
    // 判断活动是否开启
    judgeStart() {
      let _this = this;
      this.$jsonp(this.$apis("xy_startTime"), {}, (res) => {
        _this.startTime = res.data.data.start_time;
        _this.endTime = res.data.data.end_time;
        let nowTime = _this.$tool.getTimeC();
        if (nowTime < _this.startTime) {
          _this.isStart = 0; // 0未开始
        } else if (nowTime >= _this.startTime && nowTime < _this.endTime) {
          _this.isStart = 1; // 1开始
        } else {
          _this.isStart = 2; //1结束
        }
      });
    },

    // 判断当前账号是用户还是主播
    judgeIsAnchorFun() {
      let _this = this;
      this.$jsonp(this.$apis("me"), {}, (res) => {
        _this.isAnchor = res.body.data.result.isachor;
        if (_this.isAnchor == 0) {
          _this.zibtnAc = 1;
        } else {
          _this.zibtnAc = 0;
        }
        // 判断链接上是不是有anchor 有点击选择心愿后还返回那个直播间
        _this.judgeFromLive(); // 判断是否来自直播间
      });
    },

    // 获取心愿列表
    getWishList() {
      let _this = this;
      let data = {
        type: 0,
      };
      this.$jsonp(this.$apis("xy_wishList"), data, (res) => {
        _this.anchorWishList = res.data.data.anchor_wish_list;
        _this.userWishList = res.data.data.user_wish_list;
        for (let i = 0; i < _this.anchorWishList.length; i++) {
          _this.anchorWishList[i].isSele = false;
          if (_this.anchorWishList[i].status == 1) {
            _this.anchorIdx = i;
            _this.showYello = true;
          }
        }
        for (let n = 0; n < _this.userWishList.length; n++) {
          if (_this.userWishList[n].status == 1) {
            _this.userIdx = n;
          }
        }
        _this.judgeIsAnchorFun();
      });
    },

    // 顶部按钮的切换
    btnClick(idx) {
      this.zibtnAc = idx;
    },

    // 主播心愿的点击添加黄色边框
    seleXinBox(n, idx) {
      if (this.isStart == 0 || this.isStart == 2) {
        return false;
      } else {
        if (this.isAnchor > 0) {
          this.anchorIdx = idx;
          this.showYello = true;
        } else {
          this.$tool.tip("您当前身份不是主播哦~", "50%");
        }
      }
    },

    // 主播选择心愿 0   用户选择心愿1
    seleXinFun(type) {
      let _this = this;
      document.querySelector(".btn_sele").classList.add("ani_btn");
      if (type == 0 && this.anchorIdx == null) {
        _this.$tool.tip("请选择心愿", "50%");
      } else if (type == 1 && _this.userIdx == null) {
        _this.$tool.tip("请选择心愿", "50%");
      } else {
        if (this.anchorIdx >= 0 && type == 0) {
          // 主播心愿的发送
          let w_id = this.anchorWishList[this.anchorIdx].wish_id;
          this.addWishFun(1, w_id, this.anchorIdx);
        } else if (this.userIdx >= 0 && type == 1) {
          // 用户心愿的跳转
          let w_id = this.userWishList[this.userIdx].wish_id;
          this.addWishFun(2, w_id, this.userIdx);
        }
      }
    },

    // 选择心愿后的添加心愿
    addWishFun(type, w_id, idx) {
      let _this = this,
        data = {
          ident: type, // 1主播  2用户
          wish_id: w_id,
        };
      if (type == 1) {
        if (_this.$route.query.anchor) {
          data.anchor_user_id = _this.$route.query.uid;
        }
        this.$jsonp(this.$apis("xy_addwish"), data, (res) => {
          if (res.data.data.status == 1) {
            _this.anchorWishList.forEach((item) => {
              item.isSele = false;
              item.status = 0;
            });
            _this.anchorWishList[idx].status = 1;
            _this.showYello = true;
            _this.anchorIdx = idx;
            _this.$tool.tipImg("心愿选择成功", "success");
            if (_this.$route.query.anchor) {
              // 链接上有anchor就返回到直播间
              setTimeout(() => {
                _this.$appAc.closeWeb();
              }, 1000);
            }
          } else {
            _this.$tool.tip(res.data.data.msg, "50%");
          }
        });
      } else {
        if (_this.$route.query.anchor) {
          data.anchor_user_id = _this.$route.query.uid;
        }
        this.$jsonp(this.$apis("xy_addwish"), data, (res) => {
          if (res.data.data.status == 1) {
            _this.userWishList.forEach((ele) => {
              ele.status = 0;
            });
            _this.userWishList[idx].status = 1;
            _this.userIdx = idx;
            _this.$tool.tipImg("心愿选择成功", "success");
            if (_this.$route.query.anchor) {
              // 链接上有anchor就返回到直播间
              setTimeout(() => {
                _this.$appAc.closeWeb();
              }, 1000);
            } else {
              //活动页面进来的就跳到搜索主播页面
              setTimeout(() => {
                _this.$router.push("/xy_ss?w_id=" + w_id);
              }, 1000);
            }
          } else {
            _this.$tool.tip(res.data.data.msg, "50%");
          }
        });
      }
    },

    // 用户心愿点击添加黄色边框
    seleUserFun(idx) {
      if (this.isStart == 0 || this.isStart == 2) {
        return false;
      } else {
        this.userIdx = idx;
      }
    },

    // 我的记录的点击
    myRecordFun(type) {
      if (this.isStart == 0) {
        this.$tool.tip("当前活动未开始", "50%");
      } else {
        this.$router.push("/xy_myrecord?type=" + type);
      }
    },

    //判断是否来自直播间
    judgeFromLive() {
      if (this.$route.query.anchor) {
        let anchor = this.$route.query.anchor;
        if (anchor == 0) {
          //用户
          this.zibtnAc = 1;
        } else {
          //主播
          this.zibtnAc = 0;
        }
      }
    },
  },
};
</script>










<style scoped>
#xy_yu {
  width: 100%;
  padding-top: 20px;
}
/* 按钮区域 */
.btn_con {
  width: 55%;
  height: 34px;
  line-height: 34px;
  margin: auto;
  background-color: #761ec2;
  border-radius: 50px;
  box-sizing: border-box;
  padding: 1px;
}
.zi_b_box {
  width: 100%;
  height: 32px;
  background-color: #3b0a71;
  border-radius: 50px;
}
.p_btn {
  width: 50%;
  text-align: center;
  font-size: 13px;
  color: #b19dc6;
  line-height: 34px;
}
.btn_con .zi_b_box .mar_r {
  margin-right: -1px;
}
.btn_con .zi_b_box .mar_l {
  margin-left: -1px;
}
.btn_con .btnActive {
  height: 100%;
  height: 33px;
  margin-top: -1px;
  line-height: 33px;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(to bottom, #ac4bcd, #5d1496);
  background: -webkit-linear-gradient(top, #ac4bcd, #5d1496);
  border: 1px solid #ce7aff;
  border-radius: 50px;
}
/* 心愿主体区域 */
.main_box {
  width: 100%;
  padding: 0 6%;
}
.z_top_text {
  justify-content: space-between;
  margin-top: 20px;
  padding: 0 8px;
}
.z_top_text .p1 {
  font-size: 0.75rem;
  color: #ffd863;
}
.z_top_text .p2 {
  font-size: 13px;
  color: #fff;
}
.ulBox {
  padding: 0 2.5%;
  flex-wrap: wrap;
}
.ulBox .li_fa:nth-child(3n) {
  margin-right: 0;
}
.li_fa {
  margin-right: 3%;
  margin-top: 5%;
  border-radius: 6px;
  /* overflow: hidden; */
  box-sizing: border-box;
  padding: 2px;
  background-image: -webkit-linear-gradient(
    top,
    #f8ddff 0%,
    #d8a8e0 30%,
    #8d2894 90%
  );
  background-image: linear-gradient(
    to bottom,
    #f8ddff 0%,
    #d8a8e0 30%,
    #8d2894 90%
  );
}
.wai_box {
  width: 100%;
  height: 100%;
  margin: auto;
  padding: 1px;
  border-radius: 6px;
  background: linear-gradient(to bottom, #a852bf, #6676e3);
  background: -webkit-linear-gradient(top, #a852bf, #6676e3);
}
.yi_imgtc {
  width: 100%;
  height: 100%;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  z-index: 8;
}
.img_b {
  margin: auto;
  margin-top: 1px;
  background: linear-gradient(to bottom, #6409b1, #7822be, #4704a9);
  background: -webkit-linear-gradient(top, #6409b1, #7822be, #4704a9);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.img_b img {
  width: 80%;
}
.li_con {
  height: 100%;
}
.g_name {
  margin: auto;
  padding: 0 3px;
  height: 30%;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #320967;
  font-size: 0.6875rem;
  color: #8f9eed;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: #59338b 0 -2px 2px;
}
.yello_box {
  border: 5px solid #ffd863;
  border-radius: 10px;
}
/* 点击缩小的动画 */
.btn_sele {
  margin-top: 16px;
}
.ani_btn {
  animation: btnScale 0.3s linear 1 alternate;
}
/* 用户心愿的选择 */
.ul_xin {
  padding: 0 2.5%;
  flex-wrap: wrap;
  justify-content: space-between;
}
.ul_xin .u_li:nth-child(1),
.ul_xin .u_li:nth-child(2) {
  margin-top: 10px;
}
.u_li {
  width: 47%;
  margin-top: 20px;
}
.u_li .juanbg {
  width: 100%;
}
.u_xname {
  top: 53%;
  transform: translateY(-50%);
  left: 26%;
  width: 60%;
  color: #fff;
  font-size: 0.75rem;
  align-items: center;
  z-index: 3;
}
.juan_ac {
  top: 0;
  left: 0;
  z-index: 2;
}
.uselet_tc {
  right: 5px;
  top: 24%;
  width: 81%;
  height: 90%;
  z-index: 4;
}
</style>